import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const getStoreMetaDataApi = async (id) =>
    Promise.resolve(axios.get(endpoints.getStoreMetaData.replace("{id}", id)));
